"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ErrorAlert, ErrorDialog, ErrorState } from "./index";

export function ErrorExample() {
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className="space-y-8 p-6">
      <div className="space-y-4">
        <h2 className="text-lg font-medium">Error Alert Dialog Example</h2>
        <Button 
          variant="destructive" 
          onClick={() => setShowAlertDialog(true)}
        >
          Show Alert Dialog
        </Button>
        
        <ErrorAlert 
          isOpen={showAlertDialog}
          onOpenChange={setShowAlertDialog}
          title="Payment Processing Failed"
          description="We were unable to process your payment at this time."
          errorMessage="Error code: PAYMENT_DECLINED"
          supportInfo="Please have your transaction ID ready when contacting support."
          actionText="Try Again"
          onAction={() => console.log("Action triggered")}
        />
      </div>

      <div className="space-y-4">
        <h2 className="text-lg font-medium">Error Dialog Example</h2>
        <Button 
          variant="destructive" 
          onClick={() => setShowDialog(true)}
        >
          Show Error Dialog
        </Button>
        
        <ErrorDialog 
          isOpen={showDialog}
          onOpenChange={setShowDialog}
          title="License Activation Failed"
          description="We were unable to activate your license at this time."
          errorMessage="Server returned status: 403 Forbidden"
          cancelText="Back"
          actionText="Try Again"
          accountId="12345abcdef"
          onAction={() => console.log("Action triggered")}
          onCancel={() => console.log("Cancel triggered")}
        />
      </div>

      <div className="space-y-4">
        <h2 className="text-lg font-medium">Inline Error State Example</h2>
        
        <ErrorState 
          title="Network Error"
          description="We couldn't connect to the server. Please check your internet connection."
          actionText="Retry Connection"
          onAction={() => console.log("Retry connection")}
        />
      </div>
    </div>
  );
} 